export enum EarliestProcessingTime {
  FromReceipt = '1',
  AfterAcceptance = '0'
}
